import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ModalState } from './modal.reducer';

export const modalStateKey = 'modal';

export const selectModalState = createFeatureSelector(modalStateKey);

export const selectOpen = createSelector(
  selectModalState,
  (modalState: ModalState) => modalState.open,
);

export const selectClose = createSelector(
  selectModalState,
  (modalState: ModalState) => modalState.close,
);
